import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Qué es Deco Tricotín?',
  a: 'Deco Tricotín es un producto digital para aprender a crear piezas decorativas con tricotín desde cero, usando guías, plantillas y recursos listos para usar.'
}, {
  q: '¿Es un producto físico o digital?',
  a: 'Es un producto 100% digital. No recibís nada físico en tu casa.'
}, {
  q: '¿Cuándo recibo el acceso?',
  a: 'El acceso es inmediato. Después de comprar, recibís el material para descargar y empezar a usar.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. Está pensado para principiantes, con explicaciones simples para que puedas empezar aunque nunca hayas hecho tricotín.'
}, {
  q: '¿Necesito máquina de tricotín?',
  a: 'No es obligatorio. Podés empezar con técnica manual. Si ya tenés máquina, también podés usarla.'
}, {
  q: '¿Las plantillas se pueden imprimir?',
  a: 'Sí. Podés descargarlas e imprimirlas para usarlas como guía al momento de armar tus diseños.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-3xl mx-auto" data-id="element-44">
      <div className="text-center mb-8 sm:mb-12 px-2" data-id="element-45">
        <h2 className="text-2xl sm:text-4xl text-brand-text mb-4 font-bold leading-tight" data-id="element-46">
          Preguntas frecuentes
        </h2>
      </div>

      <div className="space-y-3 sm:space-y-4" data-id="element-47">
        {faqs.map((faq, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i * 0.1
      }} className="bg-brand-card rounded-[1.5rem] sm:rounded-[2rem] border border-brand-sand overflow-hidden shadow-sm" data-id="element-48">
            <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 sm:px-6 sm:py-5 flex items-center justify-between text-left hover:bg-brand-bg transition-colors" data-id="element-49">
              <span className="font-serif font-bold text-base sm:text-lg text-brand-text pr-6 leading-tight" data-id="element-50">
                {faq.q}
              </span>
              <ChevronDown className={`text-brand-cta shrink-0 transition-transform duration-300 ${openIndex === i ? 'rotate-180' : ''}`} size={24} data-id="element-51" />
            </button>

            <AnimatePresence data-id="element-52">
              {openIndex === i && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-53">
                  <div className="px-5 pb-5 pt-1 sm:px-6 sm:pb-6 text-brand-text/80 leading-relaxed font-normal text-sm sm:text-base border-t border-brand-sand/50" data-id="element-54">
                    {faq.a}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </motion.div>)}
      </div>
    </section>;
}